"use strict";
/**
 * @author by Gor.Hakobyan on 16-May-18.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var IndicatorFrameworkItems = /** @class */ (function () {
    function IndicatorFrameworkItems() {
    }
    return IndicatorFrameworkItems;
}());
exports.IndicatorFrameworkItems = IndicatorFrameworkItems;
//# sourceMappingURL=indicator-frameworks-connection.model.js.map